import * as React from 'react';
import {
    FormGenerator,
    AbstractControl,
    FieldConfig,
    GroupProps,
    FormGroup
} from 'react-reactive-form';
import { Col, Button } from 'react-bootstrap';
import { constants } from '../../../constants/constants';
import { toastr } from 'react-redux-toastr';
import { WithTranslation } from 'react-i18next';
import {
    updateDocumentType,
    deleteDocumentType
} from '../../../actions/manageDocumentTypeActions';
import { IDocumentType } from '../../../models';
import { FormUtil } from '../../common/FormUtil';
import { MobileButtonGroup } from '../../common/mobile/CommonMobileModal';

interface Iprops {
    toggleEditDocumentTypeModal: () => void;
    loading: boolean;
    colorButton: string;
    selectedDocumentType: IDocumentType;
    updateDocumentType: typeof updateDocumentType;
    deleteDocumentType: typeof deleteDocumentType;
    isMobile?: boolean;
}

const fieldConfig = (selectedDocumentType: IDocumentType) => {
    return {
        controls: {
            name: {
                options: {
                    validators: [FormUtil.validators.requiredWithTrim]
                },
                render: FormUtil.TextInput,
                meta: {
                    label: 'typeName',
                    colWidth: 12,
                    name: 'type-name'
                },
                formState: {
                    value: selectedDocumentType
                        ? selectedDocumentType.name
                        : '',
                    disabled: false
                }
            }
        } as {
            [key: string]: GroupProps;
        }
    };
};

export class EditDocumentTypeForm extends React.Component<
    Iprops & WithTranslation,
    {}
> {
    private form: FormGroup | any;
    private fieldConfig: FieldConfig;

    constructor(props: Iprops & WithTranslation) {
        super(props);
        this.fieldConfig = FormUtil.translateForm(
            fieldConfig(this.props.selectedDocumentType),
            this.props.t
        );
    }

    handleEdit = (e: React.MouseEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (this.form.status === 'INVALID') {
            this.form.markAsSubmitted();
            toastr.error(
                this.props.t('toastMessage:invalidFormSubmission'),
                '',
                constants.toastrError
            );
            return;
        }

        const { name } = this.form.value;
        this.props.updateDocumentType({
            ...this.props.selectedDocumentType,
            name
        });

        this.props.toggleEditDocumentTypeModal();
    };

    handleDelete = () => {
        const toastrConfirmOptions = {
            onOk: () => {
                this.props.deleteDocumentType(
                    this.props.selectedDocumentType.id
                );
                this.props.toggleEditDocumentTypeModal();
            },
            OnCancel: () => console.info('CANCEL: clicked'),
            okText: this.props.t('common:delete'),
            cancelText: this.props.t('common:cancel')
        };
        toastr.confirm(
            this.props.t('deleteDocumentType'),
            toastrConfirmOptions
        );
    };

    setForm = (form: AbstractControl) => {
        this.form = form;
        this.form.meta = {
            loading: this.props.loading
        };
    };

    render() {
        const { t, isMobile } = this.props;
        const buttons = (
            <>
                <Button
                    bsStyle={isMobile ? 'default' : 'link'}
                    type="button"
                    className={isMobile ? '' : 'pull-left'}
                    onClick={this.props.toggleEditDocumentTypeModal}
                >
                    {t('common:cancel')}
                </Button>
                <Button
                    bsStyle="warning"
                    type="button"
                    style={isMobile ? undefined : { marginRight: '15px' }}
                    onClick={this.handleDelete}
                >
                    {t('common:delete')}
                </Button>
                <Button
                    bsStyle={this.props.colorButton}
                    type="submit"
                    disabled={this.props.loading}
                >
                    {t('common:save')}
                </Button>
            </>
        );
        return (
            <form onSubmit={this.handleEdit} className="clearfix beacon-form">
                <FormGenerator
                    onMount={this.setForm}
                    fieldConfig={this.fieldConfig}
                />
                {isMobile ? (
                    // same fixed bottom bar as the other mobile modals
                    <MobileButtonGroup>{buttons}</MobileButtonGroup>
                ) : (
                    <Col xs={12} className="form-buttons text-right">
                        {buttons}
                    </Col>
                )}
            </form>
        );
    }
}
